import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Announce = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Announce' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M11,15 C14,15 19,19 19,19 L19,3 C19,3 14,7 11,7 C11,7 11,15 11,15 Z M5,15 L8,23 L12,23 L9,15 M19,14 C20.657,14 22,12.657 22,11 C22,9.343 20.657,8 19,8 M11,19 C11.9999997,18.9999994 14,18 14,16 M2,11 C2,7.88888889 3.7912,7 6,7 L11,7 L11,15 L6,15 C3.7912,15 2,14.1111111 2,11 Z' />
  </StyledIcon>
);
